// Authority comes from persisted server columns, projected into API attributes.
export function whatsappRevocation(attributes = {}) {
  const meta = attributes.bcwRevocationV1 || attributes.bcw_revocation_v1;
  if (meta?.version !== 1 || !Number.isSafeInteger(meta.timestamp)) return null;
  return {
    hidden: attributes.bcwHiddenRevokeNotice === true || attributes.bcw_hidden_revoke_notice === true,
    label: { self: '你撤回了一条消息', other: '对方撤回了一条消息' }[meta.actor] || '该消息已撤回',
  };
}
